<template>
  <a :href="link" target="_blank" class="py-1">
    <v-btn variant="outlined" size="small" color="info" style="background-color: white">
      Join
      <template #append>
        <zoomVideo style="height: 20px; width: 20px" viewBox="0 0 48 48" />
      </template>
      <v-tooltip activator="parent" location="bottom" class="custom-tooltip"
        >Zoom Meeting</v-tooltip
      >
    </v-btn>
  </a>
</template>

<script setup lang="ts">
import zoomVideo from "@/assets/icons/zoom_video.svg";
defineProps<{ link: string }>();
</script>

<style scoped lang="scss">
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;
</style>
